<template>
  <section class="requestContainer" @click="openGroupPreview($event)">
    <div class="flexRow">
      <img class="leftSidePic" :src="post.profileImage" />
      <div style="padding-left: 15px">
        <p class="notifTitle">{{ post.content }}</p>
        <p class="notifText">Requested to join</p>
      </div>
    </div>
    <div class="selectionRow">
      <button @click="acceptRequest" class="requestButton">Accept</button>
      <button @click="rejectRequest" class="requestButton">Reject</button>
    </div>
  </section>
</template>

<script>
import db from "@/db";
import firebase from "@/firebase";
import { mapState, mapActions } from "vuex";

export default {
  props: ["post"],

  components: {},

  data: () => ({
    type: "",
  }),
  mounted() {},

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", ["curGroup", "groupId", "groupName"]),
  },

  methods: {
    ...mapActions("user", ["updateUserGroups"]),
    ...mapActions("messageBoard", ["setSearchGroup", "subscribeToTopic"]),
    openGroupPreview(event) {
      if (
        event.target.className !== "requestButton reject" &&
        event.target.className !== "requestButton accept"
      ) {
        db.collection(this.type)
          .doc(this.group.group_id)
          .get()
          .then((doc) => {
            var previewCourse = doc.data();
            previewCourse.type = this.type;
            previewCourse.id = this.group.group_id;
            this.$store.commit("messageBoard/setGroupPreview", previewCourse);
            this.$store.commit("messageBoard/setSearchGroup", true);
          });
      }
    },
    async acceptRequest() {
      db.collection("posts")
        .doc(this.post.id)
        .delete();
      let index = this.curGroup.recentPosts.findIndex(
        (post) => post.id === this.post.id
      );
      this.curGroup.recentPosts.splice(index, 1);
      let requestIndex = this.curGroup.requests.findIndex(
        (request) => request.user_id === this.post.user_id
      );
      this.curGroup.requests.splice(requestIndex, 1);
      let newUser = {
        id: this.post.user_id,
        name: this.post.content,
        profileImage: this.post.profileImage,
      };

      db.collection("groups")
        .doc(this.groupId)
        .update({
          recentPosts: this.curGroup.recentPosts,
          requests: this.curGroup.requests,
          users: firebase.firestore.FieldValue.arrayUnion(newUser),
          userCount: firebase.firestore.FieldValue.increment(1),
        });
      var group = {
        id: this.groupId,
        lastVisited: 0,
        name: this.groupName,
        notificationsEnabled: true,
      };
      db.collection("users")
        .doc(this.post.user_id)
        .update({
          groups: firebase.firestore.FieldValue.arrayUnion(group),
        });
      db.collection("users")
        .doc(this.post.user_id)
        .get()
        .then((doc) => {
          var subscribeToTopic = firebase
            .functions()
            .httpsCallable("subscribeToTopic");
          subscribeToTopic({
            tokens: doc.data().iOSToken ? doc.data().iOSToken : "",
            groupId: this.groupId,
          });
          var directNotif = firebase
            .functions()
            .httpsCallable("sendDirectNotification");
          directNotif({
            token: doc.data().iOSToken ? doc.data().iOSToken : "",
            name: this.user.firstName + " " + this.user.lastName,
            groupName: this.groupName,
            content:
              this.user.firstName +
              " " +
              this.user.lastName +
              " accepted your group request",
          });
        });

      var joinedContent =
        this.user.firstName +
        " " +
        this.user.lastName +
        " accepted " +
        this.post.content +
        "'s request";

      this.groupPost(joinedContent, this.curGroup);
      var acceptRequest = firebase
        .functions()
        .httpsCallable("sendPostRequestNotification");
      acceptRequest({
        id: this.groupId,
        groupName: this.groupName,
        content: joinedContent,
      });
    },
    rejectRequest() {
      let index = this.curGroup.recentPosts.findIndex(
        (post) => post.id === this.post.id
      );
      this.curGroup.recentPosts.splice(index, 1);
      let requestIndex = this.curGroup.requests.findIndex(
        (request) => request.user_id === this.post.user_id
      );
      this.curGroup.requests.splice(requestIndex, 1);
      db.collection("groups")
        .doc(this.groupId)
        .update({
          recentPosts: this.curGroup.recentPosts,
          requests: this.curGroup.requests,
        });
      db.collection("users")
        .doc(this.post.user_id)
        .get()
        .then((doc) => {
          var directNotif = firebase
            .functions()
            .httpsCallable("sendDirectNotification");
          directNotif({
            token: doc.data().iOSToken ? doc.data().iOSToken : "",
            name: this.user.firstName + " " + this.user.lastName,
            groupName: this.groupName,
            content:
              this.user.firstName +
              " " +
              this.user.lastName +
              " rejected your group request",
          });
        });
      var joinedContent =
        this.user.firstName +
        " " +
        this.user.lastName +
        " rejected " +
        this.post.content +
        "'s request";

      this.groupPost(joinedContent, this.curGroup);
      var rejectRequest = firebase
        .functions()
        .httpsCallable("sendPostRequestNotification");
      rejectRequest({
        id: this.groupId,
        groupName: this.groupName,
        content: joinedContent,
      });
    },
    groupPost(content, group) {
      const id = "p" + db.collection("posts").doc().id;
      db.collection("posts")
        .doc(id)
        .set({
          content: content,
          chat_id: group.id,
          created_at: Date.now(),
        });
      if (!group.recentPosts) {
        group.recentPosts = [];
      }
      group.recentPosts.push({
        content: content,
        chat_id: group.id,
        created_at: Date.now(),
        id: id,
      });
      while (group.recentPosts.length > 25) {
        group.recentPosts.splice(0, 1);
      }
      db.collection(group.type)
        .doc(group.id)
        .update({
          recentPosts: group.recentPosts,
        });
    },
  },
};
</script>

<style scoped>
.requestContainer {
  display: flex;
  flex-direction: column;
  width: fit-content;
  border: 1px solid #a0a0a0;
  border-radius: 10px;
  padding: 10px;
}
.requestButton {
  height: 30px;
  font-size: 18px;
  width: fit-content;
  border-radius: 5px;
  margin: 3px;
  cursor: pointer;
  border: none;
  background-color: white;
}

.requestButton:hover {
  background-color: #d0d0d0;
}
.notifTitle {
  color: black;
  font-weight: bold;
}
.notifText {
  font-size: 13px;
}
.selectionRow {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: auto;
  margin-right: 0;
  justify-content: space-evenly;
}
.reject {
  background-image: url("../assets/linkDeny.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
.accept {
  background-image: url("../assets/linkAccept.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
</style>
